import '../scss/login.scss'
require('dotenv').config()

document.addEventListener('DOMContentLoaded', function (event) {
  console.log('login.js process.env.MODE:', process.env.MODE)
})
